import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { login, setAuthToken } from '../api/alertApi';

export default function Login({ onLoggedIn }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const loginMutation = useMutation({
    mutationFn: () => login(username.trim(), password),
    onSuccess: (data) => {
      setAuthToken(data.token);
      onLoggedIn(data.username);
    },
  });

  function handleSubmit(e) {
    e.preventDefault();
    loginMutation.mutate();
  }

  return (
    <div style={page}>
      <form style={card} onSubmit={handleSubmit}>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#0f172a' }}>IoT Alert Module</div>
        <div style={{ color: '#64748b', fontSize: 14, marginTop: 4, marginBottom: 24 }}>
          Sign in to continue
        </div>

        <label style={field}>
          <span style={label}>Username</span>
          <input
            style={input}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
            autoComplete="username"
          />
        </label>

        <label style={{ ...field, marginTop: 14 }}>
          <span style={label}>Password</span>
          <input
            style={input}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </label>

        {loginMutation.isError && (
          <div style={errorBox}>
            {loginMutation.error?.response?.data?.error || 'Login failed'}
          </div>
        )}

        <button style={submitButton} type="submit" disabled={loginMutation.isPending || !username.trim() || !password}>
          {loginMutation.isPending ? 'Signing in…' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}

const page = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#f8fafc',
};

const card = {
  width: 360,
  maxWidth: 'calc(100vw - 48px)',
  background: '#fff',
  border: '1px solid #e5e7eb',
  borderRadius: 20,
  padding: 32,
  boxShadow: '0 20px 50px rgba(15, 23, 42, 0.08)',
};

const field = {
  display: 'grid',
  gap: 6,
};

const label = {
  color: '#334155',
  fontSize: 13,
  fontWeight: 600,
};

const input = {
  width: '100%',
  boxSizing: 'border-box',
  border: '1px solid #cbd5e1',
  borderRadius: 12,
  padding: '10px 12px',
  fontSize: 14,
  color: '#0f172a',
  background: '#fff',
};

const errorBox = {
  marginTop: 14,
  padding: '10px 12px',
  borderRadius: 10,
  background: '#fef2f2',
  color: '#b91c1c',
  fontSize: 13,
};

const submitButton = {
  width: '100%',
  marginTop: 22,
  border: 'none',
  borderRadius: 999,
  padding: '12px 18px',
  background: '#0f766e',
  color: '#fff',
  fontWeight: 700,
  cursor: 'pointer',
  fontSize: 14,
};
